export default "__VITE_ASSET__CjQIETDy__"